import * as React from 'react'
import { Helmet } from 'react-helmet'
import { Link, graphql } from 'gatsby'
import Layout from '../components/Layout'

class TagRoute extends React.Component {
  render() {
    const posts = this.props.data.allMarkdownRemark.edges
    const tag = this.props.pageContext.tag
    const title = this.props.data.site.siteMetadata.title
    const totalCount = this.props.data.allMarkdownRemark.totalCount
    const tagHeader = `${totalCount} article${
      totalCount === 1 ? '' : 's'
    } tagged with "${tag}"`

    return (
      <Layout>
        <section className="section tag-archive-section">
          <Helmet title={`${tag} | ${title}`} />
          <div className="container content">
            <div className="columns">
              <div className="column is-10 is-offset-1 tag-archive">
                <header className="tag-archive-header">
                  <div className="tag-archive-header-main">
                    <p className="tag-archive-kicker">Tag archive</p>
                    <h1 className="title is-size-2 has-text-weight-bold">
                      {tag}
                    </h1>
                    <p className="tag-archive-summary">{tagHeader}</p>
                  </div>
                  <Link className="tag-archive-all-link" to="/tags/">
                    Explore all tags
                  </Link>
                </header>

                <div className="tag-archive-list">
                  {posts.map(({ node: post }) => {
                    const summary = post.frontmatter.description || post.excerpt

                    return (
                      <article
                        className="tag-archive-item"
                        key={post.fields.slug}
                      >
                        <div className="tag-archive-item-body">
                          <time className="tag-archive-item-date">
                            {post.frontmatter.date}
                          </time>
                          <h2>
                            <Link to={post.fields.slug}>
                              {post.frontmatter.title}
                            </Link>
                          </h2>
                          {summary ? <p>{summary}</p> : null}
                          <Link
                            className="tag-archive-read-more"
                            to={post.fields.slug}
                          >
                            Read article -&gt;
                          </Link>
                        </div>
                      </article>
                    )
                  })}
                </div>
              </div>
            </div>
          </div>
        </section>
      </Layout>
    )
  }
}

export default TagRoute

export const tagPageQuery = graphql`
  query TagPage($tag: String) {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(
      limit: 1000
      sort: { fields: [frontmatter___date], order: DESC }
      filter: { frontmatter: { tags: { in: [$tag] } } }
    ) {
      totalCount
      edges {
        node {
          fields {
            slug
          }
          excerpt(pruneLength: 180)
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            description
            title
          }
        }
      }
    }
  }
`
